import { Component, OnInit, Input } from '@angular/core';
import { IDesign } from 'rebus-models';

@Component({
  selector: 'app-guest-invitation',
  templateUrl: './guest-invitation.component.html',
  styleUrls: ['./guest-invitation.component.scss']
})
export class GuestInvitationComponent implements OnInit {

  @Input() public design: IDesign;
  public addedGuests: any[] = [];

  public carTypeList: any[] = [
    { value: 'carro', label: 'Carro' },
    { value: 'camioneta', label: 'Camioneta' }
  ];
  public docTypeList: any[] = [
    { value: 'cc', label: 'Cédula' },
    { value: 'ti', label: 'Tarjeta de Identidad' }
  ];

  constructor() { }

  ngOnInit() {
  }

  public onAddGuest() {
    this.addedGuests.push(' ');
  }

  public handleSelectCarType(event) {
  }
  public handleSelectDocType(event) {
  }
}
